import Api from '../Base'

class GetGroupsBySpacePlan extends Api {
  requestUrl = `/api/SpacePlan/${this.getParams().id}/groups`
}
export default GetGroupsBySpacePlan
